










































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PlanCard extends Vue {
  @Prop({ default: false })
  public isSelected!: boolean;

  @Prop()
  public title!: string;

  @Prop()
  public price!: string;

  @Prop()
  public gdprScanLimit!: string;

  @Prop()
  public securityScanLimit!: string;

  @Prop()
  public consentManagerLimit!: string;

  @Prop()
  public monitoringLimit!: string;

  @Prop()
  public tag!: string;
}
